import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";

export default {
  props: {
    title: String,
    buttons: {
      type: Array,
      default: () => [],
    },
    showOveride: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      show: false,
      activeButtons: [],
    };
  },
  created() {
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      if (this.buttons.length) {
        this.show = data.show;
      }
    });

    this.setActiveBtns();
  },
  methods: {
    setActiveBtns() {
      this.activeButtons = this.buttons.filter((btn) => {
        //check if user has rights
        return userHasAllRights(btn.rights, this);
      });
    },
  },
  watch: {
    title() {},
    buttons() {
      this.setActiveBtns();
    },
  },
};
